import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/success-girl.svg'


const _hoisted_1 = {
  id: "modal-download-certificate",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = {
  key: 0,
  class: "time-card my-4 d-flex flex-column p-3"
}
const _hoisted_6 = { class: "text-start d-flex flex-row justify-content-start w-100" }
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = { class: "text-start d-flex flex-row justify-content-start w-100" }
const _hoisted_9 = { class: "ms-2" }
const _hoisted_10 = { class: "modal-footer py-3" }
const _hoisted_11 = ["href"]

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalDownloadCertificate',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const hour = ref('')
  const date = ref('')
  const router = useRouter()
  const pluginStore = usePlugin()

  onMounted(() => {
    modal.value = new Modal('#modal-download-certificate', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    if (pluginStore.issuedAt.trim().length === 0) {
      modal.value?.show()
      return
    }

    const [dateTimeDate = '', dateTimeHour = ''] =
      pluginStore.issuedAt.split(' ')
    date.value = dateTimeDate.split('-').reverse().join('/')
    hour.value = dateTimeHour

    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function downloadCertificate() {
    setTimeout(() => {
      router.push({
        path: '/issue/plugin/success',
      })
    }, 500)
    hide()
  }

  __expose({
    show,
    hide,
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h5", { class: "modal-title" }, "Certificado emitido!")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fs-6 text-start mt-5" }, [
            _createTextVNode(" Agora é só "),
            _createElementVNode("strong", null, "baixar o Certificado"),
            _createTextVNode(" no seu computador! ")
          ], -1)),
          (date.value.trim().length > 0 && hour.value.trim().length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Data da emissão: ")),
                  _createElementVNode("strong", _hoisted_7, _toDisplayString(date.value), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Hora da emissão: ")),
                  _createElementVNode("strong", _hoisted_9, _toDisplayString(hour.value), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createStaticVNode("<div id=\"faqAccordionWhereToStoreCertificate\" class=\"accordion mt-4\" data-v-20d99e0a><div class=\"accordion-item\" data-v-20d99e0a><div id=\"faqAccordionQuestionWhereToStoreCertificate\" class=\"accordion-header\" data-v-20d99e0a><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#faqAccordionAnswerWhereToStoreCertificate\" aria-expanded=\"false\" aria-controls=\"faqAccordionAnswerWhereToStoreCertificate\" data-v-20d99e0a> Como definir o local ideal para armazenar seu Certificado Digital? </button></div><div id=\"faqAccordionAnswerWhereToStoreCertificate\" class=\"accordion-collapse collapse\" aria-labelledby=\"faqAccordionQuestionWhereToStoreCertificate\" data-bs-parent=\"#faqAccordionWhereToStoreCertificate\" data-v-20d99e0a><div class=\"accordion-body\" data-v-20d99e0a><p class=\"text-start fs-6 m-0\" data-v-20d99e0a><strong data-v-20d99e0a>Defina um local seguro e de fácil memorização</strong> para acessar o Certificado. <br data-v-20d99e0a><br data-v-20d99e0a><strong data-v-20d99e0a>Ajuste as preferências do seu navegador</strong>, na seção <strong data-v-20d99e0a>”Downloads”</strong>, para escolher a pasta de armazenamento dos arquivos baixados. </p></div></div></div></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            class: "btn btn-primary",
            href: _unref(pluginStore).csrDownloadLink,
            target: "_blank",
            onClick: _cache[0] || (_cache[0] = () => downloadCertificate())
          }, [
            _createVNode(IconComponent, {
              name: "download",
              class: "me-2"
            }),
            _cache[6] || (_cache[6] = _createTextVNode(" Baixar Certificado e fechar "))
          ], 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}
}

})